export default {"src":"/_next/static/media/bin.3000d4e7.svg","height":28,"width":28};